import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastrModel } from 'src/app/dataModels/toastr-model';
/**
 * display alert service
 */
@Injectable({
  providedIn: 'root'
})
export class AlertService {
  /**
   * alert
   */
  alert = new BehaviorSubject<ToastrModel>({ showAlert: false, type: '', timeout: 0, message: '' });

  /**
   * constructor to inject dependency
   */
  constructor() {}

  /**
   * display alert message
   * @param type type of alert
   * @param timeout timeout for the alert, default is 5 secs
   * @param message message to be displayed
   */
  displayAlert(type, timeout = 5000, message) {
    const showAlert = true;
    this.alert.next({ showAlert, type, timeout, message });
  }

  /**
   * hides the alert
   */
  hideAlert() {
    let tm = {} as ToastrModel;
    tm.showAlert = false;
    this.alert.next(tm);
  }
}
